import trackAuthStatusLogic from "./trackAuthStatusLogic";
import logoutUserLogic from "./logoutUserLogic";
import authStatusChangedLogic from "./authStatusChangedLogic";
import loginSuccessLogic from "./loginSuccessLogic";

export default [...trackAuthStatusLogic, ...logoutUserLogic, ...authStatusChangedLogic, ...loginSuccessLogic];
